import { SlotParamsService } from "../services/SlotAppParamsService";

export interface MenuDeclaration {
  title: string;
  key: string;
  children?: MenuDeclaration[];
}

// Store as keys are for conditions on code
export enum MenuKeys {
  MEMBERS = "members",
  ALL = "all-games",
  MORE = "more",
}

// Keys are used as url link
// TODO Refactor to use Arena5Slug from SEO
export const MenuItems: MenuDeclaration[] = [
  {
    title: "All",
    key: MenuKeys.ALL,
  },
  {
    title: "Mahjongg",
    key: "mahjongg",
  },
  {
    title: "Word & Trivia",
    key: "word",
  },
  {
    title: "Arcade",
    key: "arcade",
  },
  {
    title: "Rewards",
    key: "rewards-games",
  },
  {
    title: "Members Only",
    key: MenuKeys.MEMBERS,
  },
  {
    title: "Solitaire",
    key: "solitaire",
  },
  {
    title: "More",
    key: MenuKeys.MORE,
    children: [
      {
        title: "Recently Played",
        key: "recently-played",
      },
      {
        title: "New",
        key: "new",
      },
      {
        title: "Puzzles",
        key: "puzzles",
      },
      {
        title: "Atari & Retro",
        key: "atari-games",
      },
      {
        title: "Strategy",
        key: "strategy",
      },
      {
        title: "Game Shows",
        key: "game-shows",
      },
      {
        title: "Card",
        key: "card",
      },
      {
        title: "Staying Sharp",
        key: "staying-sharp",
      },
      {
        title: "Daily",
        key: "daily-games",
      },
      {
        title: "Juegos",
        key: "juegos-espanol",
      },
    ],
  },
];

export const FlatMenuItems: MenuDeclaration[] = MenuItems.reduce(
  (acc, item) => {
    if (!item.children) {
      acc.push(item);
    } else {
      acc = acc.concat(item.children);
    }

    return acc;
  },
  []
);

export const getMenuTitleByKey = (key: string) => {
  if (key === MenuKeys.ALL) {
    return "All Games";
  }

  const found = FlatMenuItems.find((item) => item.key === key);

  if (!found) {
    return undefined;
  }

  return found.title;
};

export enum DividerText {
  MEMBERS = "Other",
}
